<template>
  <b-modal
    centered
    id="edit-mcc"
    modal-class="overflow-hidden"
    static
    scrollable
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Sửa ngành nghề</h5>
      <b-button size="sm" variant="light" @click="closeModal()"> x </b-button>
    </template>
    <form @submit.prevent="updateInfo" class="m-3">
      <div class="form-group">
        <p>Ngành nghề</p>
        <Select2
          v-model="mcc"
          :options="systemConfig.businessFields"
          placeholder="Chọn ngành nghề"
        />
      </div>
      <div class="form-group">
        <p>Ngành nghề chi tiết</p>
      </div>
      <div class="form-group">
        <Select2
          v-model="mccDetail"
          :options="getMccDetail(mcc)"
          placeholder="Chọn ngành nghề chi tiết"
        />
      </div>
      <div class="form-group" v-if="mccDetail === 'Khác'">
        <input type="text" placeholder="Ngành nghề chi tiết" v-model="mccDetailOther" />
      </div>
    </form>
    <template #modal-footer>
      <b-button class="btn-style" size="sm" type="button" variant="light" @click="closeModal()">
        Hủy bỏ
      </b-button>
      <b-button class="btn-style" type="submit" size="sm" variant="primary" @click="updateInfo()">
        Xác nhận
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  export default {
    name: 'modal-edit-mcc',
    props: {
      closeModal: {
        type: Function,
      },
      systemConfig: {
        type: Object,
      },
    },
    data() {
      return {
        showLoading: false,
        mccDetail: '',
        mcc: '',
        mccDetailOther: '',
      }
    },

    methods: {
      async updateInfo() {
        const data = {
          mcc: this.mcc,
          mccDetail: this.mccDetail,
        }
        if (this.mccDetail === 'Khác') data.mccDetail = this.mccDetailOther
        this.$emit('updateInfo', data)
      },
      getMccDetail(code) {
        const mccDetail = this.systemConfig.baseMccDetail.find(s => s.code === code)
        return mccDetail?.detail.map(e => ({ id: e, text: e }))
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
  p {
    font-size: 14px;
  }
</style>
